<ng-container
	*ngFor="let block of renderedBlocks"
	[ngSwitch]="block.type"
>
	<ng-container
		*ngSwitchCase="'heading'"
		[ngSwitch]="block.level"
	>
		<h1
			*ngSwitchCase="1"
			class="update-heading"
		>
			{{ block.text }}
		</h1>
		<h3
			*ngSwitchCase="3"
			class="update-heading"
		>
			{{ block.text }}
		</h3>
		<h4
			*ngSwitchCase="4"
			class="update-heading"
		>
			{{ block.text }}
		</h4>
		<h5
			*ngSwitchCase="5"
			class="update-heading"
		>
			{{ block.text }}
		</h5>
		<h6
			*ngSwitchCase="6"
			class="update-heading"
		>
			{{ block.text }}
		</h6>
		<h2
			*ngSwitchDefault
			class="update-heading"
		>
			{{ block.text }}
		</h2>
	</ng-container>
	<p
		*ngSwitchCase="'paragraph'"
		class="update-paragraph"
	>
		{{ block.text }}
	</p>
	<ng-container *ngSwitchCase="'list'">
		<ol
			*ngIf="block.style === 'numbered'; else bulletedList"
			class="update-list"
		>
			<li *ngFor="let item of block.items">{{ item }}</li>
		</ol>
		<ng-template #bulletedList>
			<ul class="update-list">
				<li *ngFor="let item of block.items">{{ item }}</li>
			</ul>
		</ng-template>
	</ng-container>
	<a
		*ngSwitchCase="'link'"
		[href]="block.link.href"
		class="update-link"
		[attr.target]="block.link.target"
		rel="noopener noreferrer"
	>
		{{ block.label }}
	</a>
	<blockquote
		*ngSwitchCase="'quote'"
		class="update-quote"
	>
		<p class="update-paragraph">{{ block.text }}</p>
		<footer *ngIf="block.caption">{{ block.caption }}</footer>
	</blockquote>
	<div
		*ngSwitchCase="'table'"
		class="update-table"
	>
		<table>
			<thead>
				<tr>
					<th
						*ngFor="let header of block.headers"
						scope="col"
					>
						{{ header }}
					</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let row of block.rows">
					<td *ngFor="let cell of row">{{ cell }}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<pre
		*ngSwitchCase="'code'"
		class="update-code"
	><code>{{ block.text }}</code></pre>
	<div
		*ngSwitchCase="'markdown'"
		class="update-markdown"
		[innerHTML]="block.html"
	></div>
	<figure
		*ngSwitchCase="'image'"
		class="update-media"
	>
		<img
			[src]="block.src"
			[alt]="block.alt"
			loading="lazy"
		/>
		<figcaption *ngIf="block.caption">{{ block.caption }}</figcaption>
	</figure>
	<div
		*ngSwitchCase="'gallery'"
		class="update-gallery"
	>
		<figure
			*ngFor="let image of block.images"
			class="update-media"
		>
			<img
				[src]="image.src"
				[alt]="image.alt"
				loading="lazy"
			/>
			<figcaption *ngIf="image.caption">{{ image.caption }}</figcaption>
		</figure>
	</div>
	<figure
		*ngSwitchCase="'video'"
		class="update-media"
	>
		<ng-container [ngSwitch]="block.provider">
			<video
				*ngSwitchCase="'file'"
				[src]="block.url"
				[poster]="block.thumbnail || ''"
				controls
				playsinline
				preload="none"
				[attr.aria-label]="block.title"
			></video>
			<ng-container *ngSwitchCase="'youtube'">
				<div
					*ngIf="block.videoEmbedUrl"
					class="ratio ratio-16x9"
				>
					<iframe
						[src]="block.videoEmbedUrl"
						[title]="block.title"
						allow="
							accelerometer;
							autoplay;
							clipboard-write;
							encrypted-media;
							gyroscope;
							picture-in-picture;
							web-share;
						"
						referrerpolicy="strict-origin-when-cross-origin"
						allowfullscreen
					></iframe>
				</div>
			</ng-container>
			<a
				*ngSwitchDefault
				[href]="block.link.href"
				class="update-video-preview"
				[attr.target]="block.link.target"
				rel="noopener noreferrer"
			>
				<img
					*ngIf="block.thumbnail"
					[src]="block.thumbnail"
					alt=""
					loading="lazy"
				/>
				<span
					class="update-video-play"
					aria-hidden="true"
				>
					▶
				</span>
				<span class="update-video-title">{{ block.title }}</span>
			</a>
		</ng-container>
		<figcaption *ngIf="block.caption">{{ block.caption }}</figcaption>
	</figure>
	<aside
		*ngSwitchCase="'callout'"
		class="alert update-callout mb-0"
		[class.alert-info]="block.variant === 'info'"
		[class.alert-success]="block.variant === 'success'"
		[class.alert-warning]="block.variant === 'warning'"
	>
		<strong
			*ngIf="block.title"
			class="update-callout-title"
		>
			{{ block.title }}
		</strong>
		<p
			*ngIf="block.text; else calloutMarkdown"
			class="update-paragraph"
		>
			{{ block.text }}
		</p>
		<ng-template #calloutMarkdown>
			<div
				class="update-markdown"
				[innerHTML]="block.html"
			></div>
		</ng-template>
	</aside>
	<div
		*ngSwitchCase="'actions'"
		class="update-actions"
	>
		<a
			*ngFor="let action of block.actions"
			[href]="action.link.href"
			class="btn"
			[class.btn-primary]="action.variant === 'primary'"
			[class.btn-outline-secondary]="action.variant === 'secondary'"
			[attr.target]="action.link.target"
			rel="noopener noreferrer"
		>
			{{ action.label }}
		</a>
	</div>
	<hr *ngSwitchCase="'divider'" />
</ng-container>
